const cartReducer = (state = {}, data) => {
    switch (data.type) {
        case 'UPDATE_APP_LOADING_FLAG':
            return {
                ...state,
                isAppLoading: data.value,
            };
        case 'ADD_TOASTR':
            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    [data.notification]:
                    {
                        type: data.toastrType,
                        items: data.items,
                        error: data.error,
                    },
                },
            };
        case 'REMOVE_TOASTR':
            return state.notifications ? {
                ...state,
                notifications: Object.keys(state.notifications)
                    .filter(key => key !== data.notification)
                    .reduce((obj, key) => {
                        obj[key] = state.notifications[key];
                        return obj;
                    }, {}),
            } : state;
        case 'SET_DIRTY_TIME_SLOT_SELECTION':
            return {
                ...state,
                dirtyTimeSlotSelections: {
                    ...state.dirtyTimeSlotSelections,
                    [data.deliveryArrangementId]: data.dirty,
                },
            };
        case 'RESET_DIRTY_TIME_SLOT_SELECTIONS':
            return Object.keys(state)
                .filter(key => key !== 'dirtyTimeSlotSelections')
                .reduce((obj, key) => {
                    obj[key] = state[key];
                    return obj;
                }, {});
        case 'SET_FORM_PROCESSING':
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [data.form]: data.processing,
                },
            };
        case 'SET_BILLING_ADDRESS_DISPLAY':
            return {
                ...state,
                showBillingAddress: data.value,
            };
        case 'SET_ALTERNATIVE_COLLECTOR_DISPLAY':
            return {
                ...state,
                showAlternativeCollector: data.value,
            };
        case 'SET_IS_EXPRESS_CHECKOUT':
            return {
                ...state,
                isExpressCheckout: data.value,
            };
        default:
            return state;
    }
};

export default cartReducer;
